/*
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2025-07-11 14:30:26
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2025-07-15 16:15:57
 * @FilePath: \newpigboxmanger\src\store\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogin:false,
    userData:''
  },
  getters: {
  },
  mutations: {
    setloginData(state,data){
     state.isLogin = true
   state.userData = data
    },
    loginOut(state){
      state.isLogin = false
    }
  },
  actions: {
  },
  modules: {
  }
})
